import React from 'react'
import Gallery from '../../common/Gallery'

const DiamondImages = props =>
  <fieldset>
    <label className="label">
      <strong>You must upload at least one image</strong> of the item. Upload up
      to 5 images.
    </label>
    <br />
    <Gallery {...props} />
    {props.error &&
      props.error.images &&
      <label className="note-error">
        <em className="invalid">
          {props.error.images}
        </em>
      </label>}
  </fieldset>

export default DiamondImages
